class DropCounter extends window.BAO.CustomElement() {
  constructor() {
    super()

    this.interval = null
  }

  connectedCallback() {
    super.connectedCallback()

    try {
      this.config = JSON.parse(this.dataset.config)
    } catch {
      return
    }

    this.startDate = new Date(this.config.startDate)
    this.tickMs = Number(this.config.tickMs)
    this.increment = Number(this.config.increment)

    if (
      Number.isNaN(this.startDate.getTime()) ||
      this.tickMs <= 0 ||
      !Number.isFinite(this.increment)
    ) {
      return
    }

    this.render()

    this.interval = setInterval(() => {
      this.render()
    }, 1000)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    clearInterval(this.interval)
    this.interval = null
  }

  getCurrentCount() {
    const elapsedMs = Date.now() - this.startDate.getTime()

    if (elapsedMs < 0) {
      return 0
    }

    const ticksElapsed = Math.floor(elapsedMs / this.tickMs)

    return ticksElapsed * this.increment
  }

  render() {
    const count = this.getCurrentCount()

    this.els.number.element.textContent = count.toLocaleString()
  }
}

customElements.define('drop-counter', DropCounter)
